/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * does time measurements
 */
export class StopWatch {
    constructor() {
        this._startTime = 0;
        this._stopTime = 0;
        this._running = false;
    }
    /**
     * returns the current time
     */
    currentTime() {
        return window.performance.now();
    }
    /**
     * starts the stop watch
     */
    start() {
        this._startTime = this.currentTime();
        this._running = true;
    }
    /**
     * stops the stop watch
     */
    stop() {
        this._stopTime = this.currentTime();
        this._running = false;
    }
    /**
     * returns the elapsed time (stoptime - starttime in milliseconds)
     */
    getElapsedMilliseconds() {
        if (this._running) {
            this._stopTime = this.currentTime();
        }
        return this._stopTime - this._startTime;
    }
    /**
     * returns the elapsed time in seconds
     */
    getElapsedSeconds() {
        return this.getElapsedMilliseconds() / 1000;
    }
    /**
     * prints a simple report about elapsed time to the console
     * @param name any name to identify the current measurement
     */
    printElapsed(name) {
        const currentName = name || 'Elapsed:';
        console.log(currentName, '[' + this.getElapsedMilliseconds() + 'ms]', '[' + this.getElapsedSeconds() + 's]'); // tslint:disable-line:no-console
    }
}
//# sourceMappingURL=StopWatch.js.map